import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

/**
 * Props:
 *  value: URL de la firma guardada (BD)
 *  onChange: callback(urlBase64)
 */
export default function SignatureInput({ value, onChange }) {
  const sigRef = useRef(null);

  // Firma guardada (imagen URL)
  const [signatureUrl, setSignatureUrl] = useState(value || null);

  // Estado de carga
  const [uploading, setUploading] = useState(false);

  // Dibujando actualmente
  const [drawing, setDrawing] = useState(false);

  // Sincronizar si cambia desde la BD
  useEffect(() => {
    if (value && value !== signatureUrl) {
      setSignatureUrl(value);
    }
  }, [value]);

  const clearCanvas = () => {
    if (sigRef.current) {
      sigRef.current.clear();
    }
  };

  /**
   * Guarda la firma:
   * 1. Obtiene PNG del canvas
   * 2. Lo envía al padre
   */
  const saveSignature = async () => {
    if (!sigRef.current || sigRef.current.isEmpty()) {
      alert("Debes firmar antes de guardar.");
      return;
    }

    setUploading(true);

    try {
      // Obtener PNG base64
      const base64 = sigRef.current.getTrimmedCanvas().toDataURL("image/png");

      // Simulación de subida → en cuanto tengas el endpoint lo conectamos aquí
      // Por ahora solo enviamos el base64
      setSignatureUrl(base64);
      onChange(base64);

      setDrawing(false);
    } catch (err) {
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="bg-white border border-gray-300 rounded-lg p-4 shadow-sm space-y-4">

      {/* Título */}
      <h3 className="text-lg font-semibold text-darkBrown">Firma</h3>

      {/* IMAGEN GUARDADA (solo si no estamos dibujando) */}
      {signatureUrl && !drawing && (
        <div className="space-y-3">
          <img
            src={signatureUrl}
            alt="signature"
            className="w-full h-44 object-contain border rounded-md bg-gray-50"
          />

          <button
            onClick={() => setDrawing(true)}
            className="px-4 py-2 bg-brickRed text-white rounded-md hover:bg-brickRedHover transition"
          >
            ✍️ Reemplazar firma
          </button>
        </div>
      )}

      {/* CANVAS PARA DIBUJAR */}
      {(!signatureUrl || drawing) && (
        <div className="space-y-4">
          <div className="border border-gray-400 rounded-md bg-white">
            <SignatureCanvas
              ref={sigRef}
              penColor="black"       // ✔ negro (igual a Flutter)
              canvasProps={{
                width: 500,
                height: 180,
                className: "rounded-md",
              }}
            />
          </div>

          <div className="flex gap-2">
            {/* GUARDAR */}
            <button
              onClick={saveSignature}
              disabled={uploading}
              className={`px-4 py-2 rounded-md text-white font-medium transition ${
                uploading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-brickRed hover:bg-brickRedHover"
              }`}
            >
              {uploading ? "Guardando..." : "💾 Guardar firma"}
            </button>

            {/* LIMPIAR */}
            <button
              onClick={clearCanvas}
              className="px-4 py-2 bg-gray-300 text-darkBrown rounded-md hover:bg-gray-400 transition"
            >
              🧹 Limpiar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
